import { InfoAlert } from "./styles";
import closeIcon from "./imgs/close-icon.svg";
import headerImg from "./imgs/contact-banner.webp";

const Contact = ({ onClose, eventName }) => {
  return (
    <InfoAlert>
      <div className="inner-container">
        <div className="img-container">
          <img src={headerImg} alt="header" />
          <h2>{"Contact"}</h2>
        </div>
        <div className="close-button" onClick={onClose}>
          <img src={closeIcon} alt="close" />
        </div>
        <div className="scroll-view">
          <div className="section">
            <p>
              {
                "In case you need any help please speak to a representative at Mastercard Welcome Desk or call us at the number below:"
              }
            </p>
            <div className="mb-0">
              <p className="bold">Cannes</p>
              <p>
                Sandra Tanios <a href="tel:+393452448463"> +39 345 244 84 63</a>
              </p>
              <p className="bold">Monaco</p>
              <p>
                Saffron Tate <a href="tel:+447974417143"> +44 7974 417143</a>
              </p>
            </div>
          </div>
          <div className="section bg-black">
            <p className="bold">{"Guest Information Brochure"}</p>
            {eventName === "CANNES" ? (
              <p>
                {
                  "You can find information about Cannes Film Festival and your stay in the document below."
                }
              </p>
            ) : (
              <p>
                {
                  "You can find information about Monaco Grand Prix and your stay in the document below."
                }
              </p>
            )}

            <div className="group btn-group group-reversed">
              <div
                className={"button "}
                onClick={() => {
                  window.open(
                    "https://s3.eu-west-2.amazonaws.com/www.digiseq.co.uk/cannes-info-guest-2025-empowerment.pdf",
                    "_blank",
                    "noopener,noreferrer"
                  );
                }}
              >
                <p className="bold">{"View"}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </InfoAlert>
  );
};

export default Contact;
